import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
  DoDoNot,
} from './DocumentPage';

const SlingsChainsLiftingDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Slings, Chains and Lifting Appliances – Safe System of Work"
    documentHeading="Safe System of Work: Slings, Chains and Lifting Appliances"
    meta={[
      ['Document Reference', 'PVS-SSOW-SCL'],
      ['Version', '1.0'],
      ['Date of Issue', '17th March 2026'],
      ['Next Review Date', '17th March 2028'],
      ['Activity', 'Use of slings, chains and other lifting appliances'],
      ['Review Period', '24 months'],
    ]}
    acknowledgment={{
      documentName: 'Slings, Chains and Lifting Appliances – Safe System of Work',
      documentReference: 'PVS-SSOW-SCL',
      processActivity: 'Use of Slings, Chains and Lifting Appliances',
      versionNumber: '1.0',
      dateOfIssue: '17th March 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <Section number="1" title="Introduction">
      <Paragraph>
        There is a wide range of slings, chains and other lifting appliances which present a large
        range of hazards. The primary hazards associated include manual handling injuries, crushing
        and head injuries from falling or slipping loads, and trips, slips and falls.
      </Paragraph>
    </Section>

    <Section number="2" title="Safe System of Work">
      <DoDoNot
        doItems={[
          'Only use lifting accessories that have been thoroughly examined by a competent person in the last six months.',
          'Check the weight of the object to be lifted and the safe working load of the lifting equipment.',
          'Check the safe working load of the sling, chain and other accessories.',
          'Examine all slings and chains prior to use and reject any that are found to be defective. Any defects must be reported to the Manager or Supervisor and the equipment removed from service until repaired.',
          'Use suitable packaging to protect slings from sharp edges or corners of the load.',
          'Stand well clear of all loads being lifted.',
          'Ensure the load is free before lifting.',
          'Lower loads onto adequate packing to prevent damage to the slings when withdrawing.',
          'Return slings and chains to store after use.',
          'Always hook back the free end of empty slings or chains.',
          'Be aware that as the angle between the legs of a multi-leg sling is increased, the safe working load is decreased.',
          'Only use lifting apparatus and accessories if you are authorised to do so and have the necessary level of training and skill. Obtain assistance if you are unsure.',
          'Wear appropriate PPE when required e.g. protective headwear when loads are being lifted.',
        ]}
        doNotItems={[
          'Use untested slings or chains.',
          'Use a sling or chain with any load in excess of the safe working load.',
          'Use fibre or wire rope slings near welding or flame cutting operations.',
          'Drag slings along the floor.',
        ]}
      />
    </Section>

    <Section number="3" title="Reminder">
      <Paragraph className="font-semibold">
        IF YOU HAVE ANY QUESTIONS, PLEASE ASK YOUR MANAGER OR SUPERVISOR. You have a duty not only
        to protect your own health and safety but also to ensure that your actions do not put others
        around you at risk.
      </Paragraph>
    </Section>
  </DocumentPage>
);

export default SlingsChainsLiftingDoc;
